import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Loading } from '../../CommonComponents/OPL/Loading/Loading';
import {
  invalidateFinancialPlanQuery,
  invalidateMonteCarloQuery,
} from '../../FinancialPlanOPL/Goals/helpers/legacyWhatIfsFinancialPlanHelpers';
import { EXTERNAL_HOST } from '../../ConsumerArea/ConsumerAreaConstants';

const ACTION_CANCEL = 'ACTION_CANCEL';
const ACTION_APPLY = 'ACTION_APPLY';
const NO_ACTION = 'NO_ACTION';

class FooterView extends Component {
  constructor() {
    super();
    this.onCancel = this.onCancel.bind(this);
    this.onApply = this.onApply.bind(this);
  }

  componentDidMount() {
    this.action = NO_ACTION;
  }

  componentWillUnmount() {
    if (this.action === NO_ACTION) {
      this.onCancel();
    }
  }

  onCancel() {
    const { cancel, clientId, goalId, isWhatIfDirty, fpId, currentRoute } = this.props;

    this.action = ACTION_CANCEL;
    cancel(isWhatIfDirty, clientId, goalId);

    // invalidate only if we are on OPL goal
    if (isWhatIfDirty && currentRoute.pageName === 'Goal') {
      invalidateFinancialPlanQuery({ clientId, fpId });
      invalidateMonteCarloQuery({ clientId, fpId });
    }
  }

  onApply() {
    const { applyToPlan, clientId, goalId, applyToPlanCallback } = this.props;
    this.action = ACTION_APPLY;
    applyToPlan(clientId, goalId, applyToPlanCallback);
  }

  render() {
    const { planImpactLoading, externalHost, applyDisabled } = this.props;

    if (externalHost === EXTERNAL_HOST.ALLY) {
      return (
        <button
          type="button"
          className="bg-transparent white close-button what-ifs-menu-layout-footer"
          onClick={this.onCancel}
          disabled={planImpactLoading}
        >
          Cancel
        </button>
      );
    }

    return (
      <div className="what-ifs-layout-footer">
        <footer className="what-if-footer">
          <button
            type="button"
            className="lhs outline gray"
            onClick={this.onCancel}
            disabled={planImpactLoading}
          >
            Cancel
          </button>
          <button
            style={{ width: '130px' }}
            type="button"
            className="rhs green"
            onClick={this.onApply}
            disabled={applyDisabled || planImpactLoading}
          >
            {planImpactLoading ? <Loading size="small" variant="light" /> : 'Apply To Plan'}
          </button>
        </footer>
      </div>
    );
  }
}

FooterView.defaultProps = {
  fpId: null,
  externalHost: null,
  applyDisabled: false,
};

FooterView.propTypes = {
  clientId: PropTypes.number.isRequired,
  goalId: PropTypes.string.isRequired,
  cancel: PropTypes.func.isRequired,
  isWhatIfDirty: PropTypes.bool.isRequired,
  applyToPlan: PropTypes.func.isRequired,
  applyToPlanCallback: PropTypes.func.isRequired,
  planImpactLoading: PropTypes.bool.isRequired,
  fpId: PropTypes.string,
  currentRoute: PropTypes.shape({
    pageName: PropTypes.string,
  }).isRequired,
  externalHost: PropTypes.string,
  applyDisabled: PropTypes.bool,
};

export default FooterView;
